module.exports = __webpack_public_path__ + "img/care-offer-3.0dd832ac.jpg";